import ProductSize from '../product-size';
import GenericModel from '../../generic-model';
import RequestedProductSize from '../requested-product-size';
import { HeightWidthTuple } from '../../util-classes/height-width-tuple';

export default class StandardStickerPart extends GenericModel {
  layoutDescription?: string;
  productSize?: ProductSize;
  requestedProductSize?: RequestedProductSize;

  // only for client order form
  selectedHeightWidth?: HeightWidthTuple;

  constructor() {
    super();
  }

  public canSubmitAsClient(): boolean {
    return this.productSize != null;
  }
}

// constructor comparison should be enough for now since the only context where we need this
// right now is when a client is ordering a new project
export function isStandardStickerPart(obj: any): obj is StandardStickerPart {
  return (
    obj != null && obj.constructor === StandardStickerPart.prototype.constructor
  );
}
